import validationMessages from 'vee-validate/dist/locale/cs';
//citrix.cz
export default {
    privacyLinkLabel: "zásadami ochrany osobních údajů",
    privacyLink: 'https://www.citrix.cz/about/legal/privacy/',
    privacyText: "Společnost Citrix bude zpracovávat vaše údaje pouze v souladu s našimi",
    privacyText2: "",
    resetText: "Pokud jsou ve formuláři vyplněné údaje jiné osoby, resetujte ho",
    resetText2: "",
    resetLinkText: "kliknutím sem.",
    yes: "Ano",
    no: "Ne",
    submitBtn: {
        "Submit" : "Odeslat",
        "Get the eBook" : "Get the eBook",
        "Watch demo" : "Watch demo",
        "Get the kit" : "Získat sadu zdrojů",
        "Request a demo": "Request a demo",
        "Request a call": "Request a call"
    },
    apjPrivacy:{
        title: "Jak využíváme vaše osobní údaje",
        company: "Společnost Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") bude vaše osobní údaje využívat a ukládat v souladu s platnými právními či jinými předpisy upravujícími ochranu údajů, v souladu se",
        linkText: "zásadami ochrany osobních údajů společnosti Citrix",
        part2: "a za podmínek přísně omezeného přístupu. Společnost Citrix bude vaše osobní údaje používat pouze způsobem stanoveným zásadami ochrany osobních údajů, a nikoli pro jiné účely. Společnost Citrix může v souladu se svými zásadami ochrany osobních údajů svěřit zpracování osobních údajů tuzemským nebo zahraničním podnikatelským subjektům, sdílet osobní údaje s dalšími pobočkami či dceřinými společnostmi společnosti Citrix na celém světě nebo zasílat osobní údaje tuzemským či zahraničním třetím osobám. Poskytnete-li společnosti Citrix své osobní údaje, dáváte tím souhlas k shromažďování a zpracování osobních údajů způsobem popsaným v zásadách ochrany osobních údajů společnosti Citrix.",
        privacyAccept: "Přečetl/přečetla jsem si výše uvedený text a zásady ochrany osobních údajů společnosti Citrix a souhlasím s nimi"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Společnost"
        },
        "department": {
            label: "Oddělení",
            options: [
                { value: "", text: "" },
                { value: "Application Management", text: "Správa aplikací" },
                { value: "Consulting Services", text: "Konzultační služby" },
                { value: "Education / Training", text: "Vzdělávání/školení" },
                { value: "Engineering", text: "Strojírenství" },
                { value: "Executive Office / Administration", text: "Kancelář vedení / administrativa" },
                { value: "Finance / Accounting", text: "Finance / účetnictví" },
                { value: "Human Resources", text: "Personální oddělení" },
                { value: "Information Technology - Systems", text: "IT systémy" },
                { value: "Legal", text: "Právní záležitosti" },
                { value: "Marketing / PR", text: "Marketing / PR" },
                { value: "Networking", text: "Sítě" },
                { value: "Operations / Manufacturing", text: "Provoz / výroba" },
                { value: "Pre-Sales / Technical Support", text: "Předprodejní / technická podpora" },
                { value: "Project Management", text: "Projektový management" },
                { value: "Purchasing", text: "Nákup" },
                { value: "Sales / Bus-Corp Development", text: "Prodej / vývoj obchodní společnosti" },
                { value: "Security", text: "Zabezpečení" },
                { value: "Web / Online / E-Business", text: "Webový / online / elektronický obchod" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Odvětví",
            options: [
                { value: "", text: "" },
                { value: "Consumer Packaged Goods", text: "Balené spotřební zboží" },
                { value: "Chemical Manufacturing", text: "Chemická výroba" },
                { value: "Charitable/Non-Profit", text: "Dobročinný / neziskový sektor" },
                { value: "Transportation", text: "Doprava" },
                { value: "Mining - All", text: "Důlní průmysl – vše" },
                { value: "E-Commerce", text: "Elektronický obchod" },
                { value: "Pharmaceuticals", text: "Farmacie" },
                { value: "Finance", text: "Finance" },
                { value: "Conglomerate", text: "Konglomerát" },
                { value: "Construction and Design", text: "Konstrukce a návrhy" },
                { value: "Retail/Wholesale", text: "Maloobchod/velkoobchod" },
                { value: "Business/Personal Services", text: "Obchodní / personální služby" },
                { value: "Business Consulting", text: "Obchodní konzultace" },
                { value: "Professional Services", text: "Odborné služby" },
                { value: "Personnel Services", text: "Personální služby" },
                { value: "Hospitality", text: "Pohostinství" },
                { value: "Insurance", text: "Pojištění" },
                { value: "Service Provider", text: "Poskytovatel služeb" },
                { value: "Legal", text: "Právní záležitosti" },
                { value: "Manufacturing", text: "Průmyslová výroba" },
                { value: "Real Estate", text: "Reality" },
                { value: "Household Services", text: "Služby v domácnosti" },
                { value: "Government/Local", text: "Státní instituce / místní" },
                { value: "Government/National-Federal", text: "Státní instituce / národní, federální" },
                { value: "Government/State-Province", text: "Státní instituce / státní, krajská" },
                { value: "Engineering", text: "Strojírenství" },
                { value: "Technology", text: "Technologie" },
                { value: "Telecommunication", text: "Telekomunikace" },
                { value: "Oil and Gas", text: "Těžba ropy a zemního plynu" },
                { value: "Art & Membership", text: "Umění a členství" },
                { value: "Utilities", text: "Utility" },
                { value: "Publishing/Printing", text: "Vydavatelství/tiskařství" },
                { value: "Education", text: "Vzdělávání" },
                { value: "Entertainment", text: "Zábava" },
                { value: "Health Care", text: "Zdravotní péče" },
                { value: "Agriculture", text: "Zemědělství" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Velikost společnosti",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Velikost společnosti",
            options: [
                { value: "", text: "" },
                { value: "5,001 +", text: "5 001 +" },
                { value: "1,001 to 5,000", text: "1 001 až 5 000" },
                { value: "501 to 1,000", text: "501 až 1 000" },
                { value: "251 to 500", text: "251 až 500" },
                { value: "1 to 250", text: "1 až 250" }
            ]
        },
        "Address2": {
            label: "Řádek adresy 2"
        },
        "Address3": {
            label: "Řádek adresy 3"
        },
        "city": {
            label: "Město"
        },
        "country": {
            label: "Stát"
        },
        "email": {
            label: "Pracovní e-mail"
        },
        "firstName": {
            label: "Jméno"
        },
        "lastName": {
            label: "Příjmení"
        },
        "phone": {
            label: "Telefonní číslo"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "PSČ"
        },
        "salutation": {
            label: "Oslovení",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Stát / provincie"
        },
        "address": {
            label: "Adresa"
        },
        "Job_Title__c": {
            label: "Pracovní zařazení",
            options: [
                { value: "Analyst", text: "Analytik" },
                { value: "Assistant", text: "Asistent" },
                { value: "IT Manager", text: "IT manažer" },
                { value: "Consultant", text: "Konzultant" },
                { value: "Owner / Partner", text: "Majitel / partner" },
                { value: "Architect", text: "Návrhář" },
                { value: "Business Manager", text: "Obchodní manažer" },
                { value: "Director", text: "Ředitel" },
                { value: "Network Administrator / Engineer", text: "Správce sítě / technik" },
                { value: "System Administrator", text: "Správce systému" },
                { value: "Student", text: "Student" },
                { value: "C-Level / President / VP", text: "Vysoký manažer / prezident / viceprezident" },
                { value: "Developer / Programmer", text: "Vývojář / programátor" }
            ]
        },
        "Project_Budget__c": {
            label: "Projektový rozpočet",
            options: [
                { value: "Yes", text: "Ano" },
                { value: "No", text: "Ne" },
                { value: "Unknown", text: "Nevím" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "Produkty zájmu (chcete-li zaškrtnout více možností, podržte klávesu CTRL)"
        },
        "Purchase_Timeframe__c": {
            label: "Časový rámec nákupu",
            options: [
                { value: "", text: "" },
                { value: "3 months or less", text: "3 měsíce nebo méně" },
                { value: "4 to 6 months", text: "4 až 6 měsíců" },
                { value: "7 months or more", text: "7 a více měsíců" },
                { value: "No time frame", text: "Žádný časový rámec" },
                { value: "Unknown", text: "Neurčitý" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Můžeme vám posílat e-maily?",
            options: [
                { value: "Yes", text: "Ano" },
                { value: "No", text: "Ne" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Ano" },
                { value: "No", text: "Ne" }
            ]
        },
        "OK_to_Call__c": {
            label: "Můžeme vám telefonovat?",
            options: [
                { value: "Yes", text: "Ano" },
                { value: "No", text: "Ne" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Chci, aby mě kontaktoval prodejce"
        },
        "Comments_6__c":{
            label: "Komentáře"
        }
    },
    validation: validationMessages
}